import { create } from 'zustand';

type ImageItem = {
  url: string;
  label?: string;
};

type State = {
  isViewerOpen: boolean;
  currentImageUrl: string;
  currentImageAlt: string;
  images: ImageItem[];
  currentIndex: number;
};

type Action = {
  setIsViewerOpen: (value: boolean) => void;
  setCurrentImageUrl: (value: string) => void;
  setCurrentImageAlt: (value: string) => void;
  setImages: (images: ImageItem[]) => void;
  setCurrentIndex: (index: number) => void;
  goToNext: () => void;
  goToPrevious: () => void;
};

const useImageViewerStore = create<State & Action>((set, get) => ({
  isViewerOpen: false,
  setIsViewerOpen: (value: boolean) => set({ isViewerOpen: value }),
  currentImageUrl: '',
  setCurrentImageUrl: (value: string) => set({ currentImageUrl: value }),
  currentImageAlt: '',
  setCurrentImageAlt: (value: string) => set({ currentImageAlt: value }),
  images: [],
  setImages: (images: ImageItem[]) => set({ images }),
  currentIndex: 0,
  setCurrentIndex: (index: number) => {
    const state = get();
    const newIndex = Math.max(0, Math.min(index, state.images.length - 1));
    set({
      currentIndex: newIndex,
      currentImageUrl: state.images[newIndex]?.url || state.currentImageUrl,
    });
  },
  goToNext: () => {
    const state = get();
    if (state.images.length > 0) {
      const newIndex = (state.currentIndex + 1) % state.images.length;
      set({
        currentIndex: newIndex,
        currentImageUrl: state.images[newIndex].url,
      });
    }
  },
  goToPrevious: () => {
    const state = get();
    if (state.images.length > 0) {
      const newIndex = (state.currentIndex - 1 + state.images.length) % state.images.length;
      set({
        currentIndex: newIndex,
        currentImageUrl: state.images[newIndex].url,
      });
    }
  },
}));

export default useImageViewerStore;
